/** Tick-label helpers shared by the behavior-chart query hooks (teacher and admin).
 *  Kept in one place so the thinning heuristic — which mirrors LineChart's internal
 *  step filter — has a single source of truth. */

/** "2026-04-02" → "Apr 2", "2026-03-16" → "Mar 16". Falls back to input on parse failure. */
export function formatTickLabel(isoDate: string): string {
  const [year, month, day] = isoDate.split('-').map(Number);
  if (!year || !month || !day) return isoDate;
  return new Date(year, month - 1, day).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

/** Reduces tick labels to at most 7 visible labels, aligned to the positions
 *  LineChart will actually render (it skips every Math.floor(n/50)th tick
 *  internally). Choosing indices outside that set produces empty Text elements. */
export function thinTickLabels(labels: string[]): string[] {
  const n = labels.length;
  if (n <= 7) return labels;

  const chartStep = Math.max(1, Math.floor(n / 50));
  const renderable: number[] = [];
  for (let i = 0; i < n; i += chartStep) renderable.push(i);

  const count = Math.min(7, renderable.length);
  const shown = new Set<number>();
  for (let i = 0; i < count; i++) {
    const idx = count === 1 ? 0 : Math.round((i * (renderable.length - 1)) / (count - 1));
    const pos = renderable[idx];
    if (pos !== undefined) shown.add(pos);
  }

  return labels.map((label, i) => (shown.has(i) ? label : ''));
}
